import cx from 'classnames'
import PropTypes from 'prop-types'

import Badge, {atomBadgeDesigns, atomBadgeSizes, atomBadgeTypes} from '@s-ui/react-atom-badge'
import AtomButton, {
  atomButtonColors,
  atomButtonDesigns,
  atomButtonShapes,
  atomButtonSizes
} from '@s-ui/react-atom-button'

import {BASE_CLASS_CONTENT, SIZES} from './settings.js'

const CardThumbnailContent = ({
  badgeText,
  caption,
  ctaText,
  description,
  descriptionHighlight,
  isLabelSpaceReserved,
  label,
  labelIcon,
  hasLabelStrikethrough = false,
  onCtaClick,
  size = SIZES.SMALL,
  title
}) => {
  const hasLabel = Boolean(label)
  const hasLabelIcon = Boolean(labelIcon)
  const showLabelIcon = hasLabel && hasLabelIcon
  const labelClass = `${BASE_CLASS_CONTENT}-label`
  const labelClasses = cx(labelClass, {
    [`${labelClass}--strikethrough`]: hasLabelStrikethrough,
    [`${labelClass}--hidden`]: isLabelSpaceReserved
  })

  const titleClass = `${BASE_CLASS_CONTENT}-title`
  const titleClasses = cx(titleClass, `${titleClass}--${size}`)
  const descriptionClass = `${BASE_CLASS_CONTENT}-description`
  const descriptionClasses = cx(descriptionClass, `${descriptionClass}--${size}`)
  const captionClass = cx(`${BASE_CLASS_CONTENT}-caption`)
  const hasMultipleBadges = Array.isArray(badgeText)

  const badges = hasMultipleBadges ? badgeText : [badgeText]

  return (
    <div className={BASE_CLASS_CONTENT}>
      <div className={`${BASE_CLASS_CONTENT}-top`}>
        {badgeText ? (
          <div className={`${BASE_CLASS_CONTENT}-badge`}>
            {badges.map(bdgText => (
              <Badge
                size={atomBadgeSizes.SMALL}
                type={atomBadgeTypes.INFO}
                design={atomBadgeDesigns.SOFT}
                label={bdgText}
              />
            ))}
          </div>
        ) : null}
        <span className={labelClasses}>
          {showLabelIcon ? labelIcon : null}
          {hasLabel ? label : null}
          {!hasLabel && isLabelSpaceReserved ? '-' : null}
        </span>
      </div>
      {title ? <p className={titleClasses}>{title}</p> : null}
      <div className={`${BASE_CLASS_CONTENT}-descriptionWrapper`}>
        <p className={descriptionClasses}>
          {descriptionHighlight ? (
            <span className={`${descriptionClass}--highlight`}>{descriptionHighlight}</span>
          ) : null}
          {description}
        </p>
      </div>
      {caption ? <p className={captionClass}>{caption}</p> : null}
      {ctaText ? (
        <AtomButton
          color={atomButtonColors.NEUTRAL}
          design={atomButtonDesigns.OUTLINE}
          fullWidth
          onClick={onCtaClick}
          shape={atomButtonShapes.CIRCULAR}
          size={atomButtonSizes.SMALL}
        >
          {ctaText}
        </AtomButton>
      ) : null}
    </div>
  )
}

CardThumbnailContent.displayName = 'CardThumbnailContent'
CardThumbnailContent.propTypes = {
  badgeText: PropTypes.oneOf([PropTypes.string, PropTypes.array]),
  caption: PropTypes.string,
  ctaText: PropTypes.string,
  description: PropTypes.string,
  descriptionHighlight: PropTypes.string,
  isLabelSpaceReserved: PropTypes.bool,
  label: PropTypes.string,
  labelIcon: PropTypes.node,
  hasLabelStrikethrough: PropTypes.bool,
  onCtaClick: PropTypes.func,
  size: PropTypes.oneOf(Object.values(SIZES)),
  title: PropTypes.string
}

export default CardThumbnailContent
